import { FC } from 'react'
import { Chart } from "react-google-charts";


export interface IProps {
    chartData: any
    height: number
}

const options = {
  is3D: true,
  colors: ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#ca31f5'],
  legend: {position: 'bottom'},
  pieSliceText: 'value',
  backgroundColor: 'transparent',
  chartArea: {
    width: '100%',
    height: '80%',
  },
};

const SyllabusGradingChart: FC<IProps> = ({ chartData, height }) => {

  chartData = [
    ["Subject", "Weight"],
    ...chartData
  ];
  
  return (

        <Chart
          chartType="PieChart"
          data={chartData}
          options={options}
          width={"100%"}
          height={height+"px"}
        />
    )
  
}

export default SyllabusGradingChart
